export const CLIENT_DETAIL_TABS = [
    'summary',
    'upcomingInvoices',
    'issuedInvoices'
];
export const DEFAULT_CLIENT_DETAIL_TAB = 'summary';
